import { render, staticRenderFns } from "./SystemComponentsHierarchyUpdate.vue?vue&type=template&id=05b9967e&"
import script from "./SystemComponentsHierarchyUpdate.vue?vue&type=script&lang=js&"
export * from "./SystemComponentsHierarchyUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports